module.exports = __webpack_public_path__ + "img/button_education.05055c1d.svg";